import BeforeAfterImage from "./components/BeforeAfterImage"
import _ from "lodash"

const allSliders = []
const resizeObserver = window.ResizeObserver ? new ResizeObserver(() => {
  for (const slider of allSliders) {
    slider.setSliderDivHeight()
    slider.setOffset(slider.offset)
  }
}) : null

// Global resize handler (throttled)
const globalResizeHandler = _.throttle(() => {
  for (const slider of allSliders) {
    slider.setSliderDivHeight()
    slider.setOffset(slider.offset)
  }
}, 200)

function initSlider(wrapper) {
  const slider = new BeforeAfterImage(wrapper)
  allSliders.push(slider)

  if (resizeObserver) {
    resizeObserver.observe(wrapper)
  }
}

// Lazy init via IntersectionObserver
const lazyInitSliders = () => {
  const wrappers = document.querySelectorAll(".before-after-slider-wrapper")

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const wrapper = entry.target
          initSlider(wrapper)
          obs.unobserve(wrapper)
        }
      })
    }, {
      rootMargin: "100px", // preload slightly before visible
    })

    wrappers.forEach(wrapper => observer.observe(wrapper))
  } else {
    // Fallback: init all immediately
    wrappers.forEach(wrapper => initSlider(wrapper))
  }

  window.addEventListener("resize", globalResizeHandler)
}

$(lazyInitSliders)
